export default __webpack_public_path__ + "static/media/arrow-down.2bc7d8e7.svg";